module.exports = __webpack_public_path__ + "img/新浪体育@2x.2bae7a05.png";